export const usePaymentSuccessHandler = () => {
  // Watch for payment success in URL and automatically open credits popover
  const watchForPaymentSuccess = (onOpenCreditsPopover: () => void) => {
    const route = useRoute()
    
    // Watch for route changes
    watch(() => route.query, (newQuery) => {
      const paymentStatus = newQuery.payment_status as string | undefined
      const sessionId = newQuery.session_id as string | undefined
      const creditsPurchased = newQuery.credits_purchased as string | undefined
      
      if (paymentStatus === 'success' && sessionId && creditsPurchased) {
        console.log('🎉 Payment success detected in URL - opening credits popover', { sessionId, creditsPurchased })
        
        // Open the credits popover to show success message
        onOpenCreditsPopover()
      }
    }, { immediate: true })
  }
  
  // Check immediately on mount
  const checkForPaymentSuccess = (onOpenCreditsPopover: () => void) => {
    const route = useRoute()
    const paymentStatus = route.query.payment_status as string | undefined
    const sessionId = route.query.session_id as string | undefined
    const creditsPurchased = route.query.credits_purchased as string | undefined
    
    if (paymentStatus === 'success' && sessionId && creditsPurchased) {
      console.log('🎉 Payment success detected on mount - opening credits popover', { sessionId, creditsPurchased })
      
      // Use nextTick to ensure DOM is ready
      nextTick(() => {
        onOpenCreditsPopover()
      })
    }
  }
  
  return {
    watchForPaymentSuccess,
    checkForPaymentSuccess
  }
} 